import React from 'react';
import { Provider } from 'react-redux';
import { getCompanyInfo } from '@redux/modules/companyInfo';
import Store from '@redux';

import CompanyInfoContent from './components/CompanyInfoContent';

class CompanyInfo extends React.Component {
  constructor(props) {
    super(props);

    this.store = Store.get();
  }

  componentDidMount() {
    this.store.dispatch(getCompanyInfo());
  }

  render() {
    return (
      <Provider store={this.store}>
        <CompanyInfoContent
          {...this.props}
        />
      </Provider>
    );
  }
}

CompanyInfo.displayName = 'CompanyInfo';

export default CompanyInfo;
